import React from 'react'
import {Box,Button,Card} from 'grommet'
import { withRouter } from 'react-router-dom';
import {ReturnRowDir,LoadLayer}from './utils/shared/shared'
import {CollectionDetailsCard } from './shipmentDetailsCards';
import QuoteCardShip from './quoteCardShip';
import {Transaction} from 'grommet-icons'

function returnSwitchOption(props){
  if (props.user === 'Agent'){
    return false
  } else {
    return true
  }
}

function CreateShipmentLayout(props){
  const {load} = props;  
  let label;
  if (props.collection.dg){
    label = 'Saving Shipment...'
  } else {
    label = "Creating Shipment..."
  }
  let detailsCards;
  if (props.size === 'small'){
    detailsCards = null
  } else {
    detailsCards = (
      <Box style={{position:'fixed', maxWidth: 280}}>
      <CollectionDetailsCard load={load} collection={props.collection} />
      {(props.quoteReady && props.showQuote) && (
            <QuoteCardShip error={props.error} shipmentPieceDetails={props.shipmentPieceDetails} requestQuote={props.requestQuote} quote={props.quote} load={props.quoteLoad} />
          )}   
      </Box>
      
      )
  }

  const showSwitchOption = returnSwitchOption(props)
    return (
      <Box direction='row' gap='large'>
        <Card style={{visibility:'hidden'}} margin={'small'}   pad='small'  width='small'/>
          {detailsCards}
       
          <Box>
          <LoadLayer load={load} label={label} />
          <Box direction={ReturnRowDir(props.size)} justify='between' margin='small'>
            {props.origin}
            {showSwitchOption && (
               <Box direction='column' justify='between'>
               <Box></Box>
               <Button onClick={() => props.switchLocations()} color='brand' size='small' hoverIndicator icon={<Transaction color='brand' />} />
               <Box></Box>
             </Box>
            )}
            {props.destination}
          </Box>
          <Box>       
            {props.shipmentSummary}
            {props.shipmentDetailsForm}
          </Box>
        </Box>
      </Box>
    )
  }

export default withRouter(CreateShipmentLayout)
